import React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import ImageUploads from "./ImageUploads";
import CoordinateSliders from "./CoordinateSliders";
import { buildDefaultOverlays } from "./constants";

/**
 * Left column of the Gift Card editor:
 *  - Title / Tagline / Message inputs
 *  - Main image + Logo uploads (compressed client-side)
 *  - Per-element X/Y/Size/Width/Height sliders, alignment, colour
 *
 * All state lives on the parent `form` — this component only mutates
 * it via `setForm`, exactly as the original monolithic editor did.
 */
export default function ControlPanel({ form, setForm, overlays, setOverlay }) {
  return (
    <div className="grid gap-4 max-h-[70vh] overflow-y-auto pr-2">
      <div>
        <Label>Title</Label>
        <Input value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} data-testid="gc-title" />
      </div>
      <div>
        <Label>Tagline</Label>
        <Input value={form.tagline || ""} onChange={(e) => setForm({ ...form, tagline: e.target.value })} data-testid="gc-tagline" placeholder="e.g. A gift of stillness" />
      </div>
      <div>
        <Label>Message</Label>
        <Input value={form.message || ""} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="gc-message" placeholder="Short note printed on the card" />
      </div>

      <ImageUploads form={form} setForm={setForm} />

      <CoordinateSliders
        overlays={overlays || buildDefaultOverlays()}
        hasBackground={!!form.background_image_data_url}
        setOverlay={setOverlay}
      />
    </div>
  );
}
